import { useState } from 'react';
import s from './MagicLinkPanel.module.scss';

interface Props {
  url: string;
}

/**
 * No-email-mode affordance: shows a one-time magic link with a Copy button so
 * the admin can send it to the contractor manually. Shown after create/resend.
 */
export function MagicLinkPanel({ url }: Props) {
  const [copied, setCopied] = useState(false);

  async function copy(): Promise<void> {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard API unavailable (e.g. insecure context) — fall back to select.
      const el = document.getElementById('magic-link-input') as HTMLInputElement | null;
      el?.select();
    }
  }

  return (
    <div className={s.panel}>
      <label className={s.label} htmlFor="magic-link-input">
        Vendor link
      </label>
      <div className={s.row}>
        <input id="magic-link-input" className={s.input} readOnly value={url} />
        <button type="button" className={s.copyBtn} onClick={() => void copy()}>
          {copied ? 'Copied' : 'Copy'}
        </button>
      </div>
      <p className={s.note}>
        One-time link — it expires and stops working once the vendor submits.
      </p>
    </div>
  );
}
